import React from "react";

const StepsSection = ({ patternCanvas2Ref, patternCanvas3Ref }) => {
  return (
    <section className="py-24 scroll-animation opacity-0 translate-y-8 transition-all duration-800 ease-out">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-16">
          Get started in two easy steps
        </h2>
        <div className="grid md:grid-cols-2 gap-12 max-w-4xl mx-auto">
          <div>
            <canvas
              ref={patternCanvas2Ref}
              className="rounded-2xl mx-auto"
              width="200"
              height="200"
            ></canvas>
            <h3 className="text-2xl font-semibold text-white mt-6">
              1. Click the Button
            </h3>
            <p className="text-slate-300">
              Just click the "Talk to Assistant" button to start a conversation
              instantly.
            </p>
          </div>
          <div>
            <canvas
              ref={patternCanvas3Ref}
              className="rounded-2xl mx-auto"
              width="200"
              height="200"
            ></canvas>
            <h3 className="text-2xl font-semibold text-white mt-6">
              2. Get Started
            </h3>
            <p className="text-slate-300">
              Experience the power of voice AI and see how it can transform your
              workflow.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StepsSection;
